module.exports = __webpack_public_path__ + "static/img/icon_wechat.0e8e33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_wechat.png
// module id = t3bX
// module chunks = 0